//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FooterWeixin from '@/components/views/footer_weixin'
import TopRightShare from '@/components/views/top_right_share'

const RESULT = {
    success: {
        class: 'success',
        title: '恭喜您',
        tip: '您已满足本业务办理条件'
    },
    fail: {
        class: 'fail',
        title: '非常抱歉',
        tip: '您目前的条件暂不符合办理本项业务，谢谢'
    }
}
export default {
    components: {
        TopRightShare,
        FooterWeixin
    },
    props: {
        answer: {
            type: String
        },
        answered: {
            type: Array
        },
        doc: {
            type: String
        }
    },
    computed: {
        result () {
            return RESULT[this.answer]
        },
        doc_url () {
            return this.doc || ''
        }
    }
}
